import SettingsInputHdmiOutlinedIcon from "@material-ui/icons/SettingsInputHdmiOutlined";
import { MalfunctionsDiagList } from "./MalfunctionsDiagList";

export default {
  icon: SettingsInputHdmiOutlinedIcon,
  list: MalfunctionsDiagList,
};
